module.exports = __webpack_public_path__ + "static/travel-app@2x-13c2fc7be454da82bef3038487d5338e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/examples/travel-app@2x.jpg
// module id = 881
// module chunks = 71833740541355 256871573202158